/* eslint-disable */
import GlobalSearch from '@/Components/globalSearch/search';
import { Button } from '@/Components/ui/button';
import { Filter } from 'lucide-react';
import { useEffect, useState } from 'react';
import WastageTable from './wastageTable';
import { urls } from '@/Constants';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import wastageAnalyticsServices from '@/Services/Analytics Services/wastage-analytics.services';
import { useDispatch, useSelector } from 'react-redux';
import wastageAction from '@/Actions/wastage.action';
import drawerActions from '@/Actions/drawer.actions';
import { handleExportData } from '@/Helpers';
import ImagesFinder from '@/Components/ImagesFinder/ImagesFinder';
import moment from 'moment';
import { BackdropLoader } from '@/Components/Loaders';

const wastageColMap = {
    'Store': 'fromStore',
    'Product Name': 'productVariantName',
    'Category': 'productCategoryName',
    'Sub Category': 'subCategoryName',
    'sku code': 'clientVariantId',
    'Reason': 'wastageReason',
    'Marking Type': 'markingType',
    'Marking Time': 'wastageDateTime',
    'QC Time': 'stockedInAt',
    'QR Id': 'qrCode',
    'Unit': 'unit',
};

const wastageSpecialColumns = [
    {
        title: 'Store',
        config: {
            type: 'DATA',
        },
    },
    {
        title: 'Product Name',
        config: {
            type: 'Data',
        },
    },
    {
        title: 'Category',
        config: {
            type: 'Data',
        },
    },
    {
        title: 'Sub Category',
        config: {
            type: 'Data',
        },
    },
    {
        title: 'sku code',
        config: {
            type: 'Data',
        },
    },

    {
        title: 'Reason',
        config: {
            type: 'Data',
        },
    },
    {
        title: 'Marking Type',
        config: {
            type: 'Data',
        },
    },
    {
        title: 'Marking Time',
        config: {
            type: 'Data',
        },
    },
    {
        title: 'QC Time',
        config: {
            type: 'Data',
        },
    },
    {
        title: 'QR Id',
        config: {
            type: 'Data',
        },
    },
    {
        title: 'Unit',
        config: {
            type: 'Data',
        },
    },
];

const transitColMap = {
    'Vechile No.': 'vehicleNumber',
    'Dispatched From': 'dispatchStore',
    'Received at': 'receivingStore',
    'Status': 'status',
    'Dispatch Date': 'dispatchDate',
    'Received date': 'receivingDate',
};

const transitSpecialColumns = [
    {
        title: 'Vechile No.',
        config: {
            type: 'DATA',
        },
    },
    {
        title: 'Dispatched From',
        config: {
            type: 'Data',
        },
    },
    {
        title: 'Received at',
        config: {
            type: 'Data',
        },
    },
    {
        title: 'Status',
        config: {
            type: 'Data',
        },
    },
    {
        title: 'Dispatch Date',
        config: {
            type: 'Data',
        },
    },
    {
        title: 'Received date',
        config: {
            type: 'Data',
        },
    },
];

function WastageLogs() {
    const tabs = [
        { key: 'markWastage', label: 'Marked Wastage', active: true },
        { key: 'transitLog', label: 'Transit logs', active: false },
    ];
    // const dropDownItems = [
	// 	{
	// 		label: 'Client PO ID',
	// 		value: 'clientPoId',
	// 		placeholder: 'Search by Client PO ID',
	// 		getData: true,
	// 	},
	// 	{
	// 		label: 'PO ID',
	// 		value: 'poId',
	// 		placeholder: 'Search by Po ID',
	// 		getData: true,
	// 	},
	// ];
    const [activeTab, setActiveTab] = useState('');
    // const [searchValue, setSearchValue] = useState({});
    const [filters, setFilters] = useState({});
    const [loading, setLoading] = useState(false);
    const history = useHistory();
    const dispatch = useDispatch();
    const wastageData = useSelector(state => state.wastage.wastageList);
    const transitData = useSelector(state => state.wastage.transitList);

    useEffect(() => {
       setActiveTab('markWastage');
    }, []);

    const handleListFetch = async (filters) => {
        setFilters(filters);
        setLoading(true);
        try{
            if(filters?.orderType === 'markWastage' ){
                const response = await wastageAnalyticsServices?.wastageScan({
                data: {
                  dateRangeFilter :
                  {
                    from : moment(filters?.dateRange?.from).format('YYYY-MM-DD'),
                    to:moment(filters?.dateRange?.to).format('YYYY-MM-DD')
                    }
                },
                });
                if(response?.statusCode === 200){
                    const wastageData = response?.data?.map(item => ({
                        ...item,
                        productVariantName: `${item?.productName} (${item?.variantName})`,
                    }));
                    dispatch(wastageAction.wastageList(wastageData));
                }
            }else{
                const response = await wastageAnalyticsServices?.transitLog({
                    data: {
                        dateRangeFilter : {
                            from : moment(filters?.dateRange?.from).format('YYYY-MM-DD'),
                            to:moment(filters?.dateRange?.to).format('YYYY-MM-DD')
                        }
                    }
                });
                if(response?.statusCode === 200){
                    const transitData = response?.data?.map(item => ({
                        ...item,
                        productVariantName: `${item?.productName} (${item?.variantName})`,
                    }));
                    dispatch(wastageAction.transitList(transitData));
                }
            }
        }catch(error){
            console.log(error, 'error');
        }finally{
            setLoading(false);
        }
    };

    const handleTabChange = (tab) => {
        setActiveTab(tab);
        handleListFetch({...filters, orderType: tab});
    };
    const wastageSpecialItems = {
        'Store': (_,item) => {
           return <p className='text-[12px] text-nowrap text-left'>{item}</p>;
        },
        'Product Name': (_,item) => <p className='text-[12px] text-nowrap text-left'>{item}</p>,
        'Category': (_,item) => <p className='text-[12px] text-nowrap text-left'>{item}</p>,
        'sku code': (_,item) => <p className='text-[12px] text-nowrap text-left'>{item}</p>,
        'Sub Category': (_,item) => <p className='text-[12px] text-nowrap text-left'>{item}</p>,
        'Reason': (_,item) => <p className='text-[12px] text-nowrap text-left'>{item}</p>,
        'Marking Type': (_,item) => <p className='text-[12px] text-nowrap text-left'>{item}</p>,
        'Marking Time': (_,item) => <p className='text-[12px] text-nowrap text-left'>{item}</p>,
        'QC Time': (_,item) => <p className='text-[12px] text-nowrap text-left'>{item}</p>,
        'QR Id': (_,item) => <p className='text-[12px] text-left'>{item}</p>,
        'Unit': (_,item) => <p className='text-[12px] text-nowrap text-left'>{item}</p>
    };

    const transitSpecialItems = {
        'Vechile No.': (_,item) => <p className='text-[12px] text-nowrap text-left'>{item}</p>,
        'Dispatched From': (_,item) => <p className='text-[12px] text-nowrap text-left'>{item}</p>,
        'Received at': (_,item) => <p className='text-[12px] text-nowrap text-left'>{item}</p>,
        'Status': (_,item) => <p className='text-[12px] text-nowrap text-left'>{item}</p>,
        'Dispatch Date': (_,item) => <p className='text-[12px] text-nowrap text-left'>{item}</p>,
        'Received date': (_,item) => <p className='text-[12px] text-nowrap text-left'>{item}</p>,
    };

    const filtersInfo = {
        header: {
			date: false,
		},
		dateRangeOnly: {
			show: true,
		},	
    };
    const exportInfo = {
		showExportBtn : true,
	};
    
	return (
		<>
			<div className='bg-gray-100 mb-2 w-full'>
            <BackdropLoader  isLoading={loading} showProgress={true} />
                <ImagesFinder
                    onSubmit={handleListFetch}
                    filtersInfo={filtersInfo}
                    exportInfo={exportInfo}
                    tabType={activeTab}
                />
				<div className='flex'>
					{tabs.map((tab) => (
						<div
							key={tab.key}
							className={`p-3 cursor-pointer flex items-center justify-center ${
                            activeTab === tab.key
                            	? 'bg-white border-t border-l border-r rounded-t-lg min-w-[200px] text-center text-black font-bold'
                            		: 'text-slate-600 font-bold min-w-[200px] text-center'
                        }`}
							onClick={() => handleTabChange(tab.key)}
						>
							{tab.label}
						</div>
					))}
				</div>
			</div>
            {/* search bar */}
            <div className='flex items-center gap-2 justify-end m-4'>
				{/* <GlobalSearch
					dropDownOptions={dropDownItems}
                    setSelectedValue={setSearchValue}
				/> */}
                <Button
					onClick={() => dispatch(drawerActions.toggleFiltersDrawer(true, { 
                        exportFrontend : true, 
                        handleExportFrontend : () => handleExportData(activeTab === 'markWastage' ? wastageData : transitData, activeTab === 'markWastage' ? wastageColMap : transitColMap, activeTab === 'markWastage' ? 'WastageLogs' : 'TransitLogs')}))}
                    className='flex justify-center gap-2 px-4 py-2 text-white bg-teal-600 border border-gray-300 rounded-md hover:bg-teal-700'
				>
					<span className='text-nowrap'>Filter & Export</span>
					<Filter className='size-4' />
				</Button>
			</div>
            {/* Table */}
            <div className="overflow-auto" style={{ maxHeight: 'calc(100vh - 200px)' }}>
            {activeTab === 'markWastage' && (
                <WastageTable
                    special={wastageSpecialColumns}
                    colMap={wastageColMap}
                    specialMappings={wastageSpecialItems}
                    data={wastageData}
                    filters={filters}
                    tableType='wastage'
                />
            )}
            {activeTab === 'transitLog' && (
                <WastageTable 
                    special={transitSpecialColumns}
                    colMap={transitColMap}
                    specialMappings={transitSpecialItems}
                    data={transitData}
                    filters={filters}
                    tableType='transit'
                />
            )}
            </div>
		</>
	);
}
export default WastageLogs;
